/* Snowcubes Early Feedback — drag-rank survey. Mirrors snowfeed-mvp.html with
 * Shopify adaptations: CDN-loaded SortableJS, real {% form 'contact' %} submit,
 * and ?contact_posted=true thanks gate. */
(function () {
  'use strict';

  var root = document.querySelector('[data-ef-root]');
  if (!root) return;

  var SORTABLE_CDN = 'https://cdn.jsdelivr.net/npm/sortablejs@1.15.2/Sortable.min.js';
  // Liquid renders the first view, while this script owns shuffled cards and
  // the hidden submission body. Resolve both from the same Markets payload so
  // changing language never leaves the interactive survey half translated.
  function translate(key, values) {
    var table = window.SnowcubesLocale || {};
    var value = table[key];
    if (typeof value !== 'string' || !value) value = key;
    return value.replace(/\{\{\s*([\w.-]+)\s*\}\}/g, function (_match, name) {
      return values && values[name] !== undefined ? String(values[name]) : '';
    });
  }

  var CARD_COPY = {
    organic: {
      lever: translate('pages.early_feedback.cards.organic.lever'),
      statement: translate('pages.early_feedback.cards.organic.statement')
    },
    price: {
      lever: translate('pages.early_feedback.cards.price.lever'),
      statement: translate('pages.early_feedback.cards.price.statement')
    },
    flavors: {
      lever: translate('pages.early_feedback.cards.flavors.lever'),
      statement: translate('pages.early_feedback.cards.flavors.statement')
    },
    variety: {
      lever: translate('pages.early_feedback.cards.variety.lever'),
      statement: translate('pages.early_feedback.cards.variety.statement')
    },
    local: {
      lever: translate('pages.early_feedback.cards.local.lever'),
      statement: translate('pages.early_feedback.cards.local.statement')
    },
    'gift-packaging': {
      lever: translate('pages.early_feedback.cards.gift_packaging.lever'),
      statement: translate('pages.early_feedback.cards.gift_packaging.statement')
    }
  };
  var fAP = Array.prototype.forEach;
  function each(list, fn) { fAP.call(list, fn); }
  function $$(sel, ctx) { return (ctx || root).querySelectorAll(sel); }

  var params = new URLSearchParams(window.location.search);
  // Keep the page generic. Email carries personalization; the form identifies people by entered email.
  // Post-submit: show thanks, skip wiring
  if (params.get('contact_posted') === 'true') {
    each($$('[data-ef-page]'), function (p) {
      p.classList.remove('is-active');
      p.style.display = 'none';
    });
    each($$('[data-ef-step-dot]'), function (d) {
      d.classList.remove('is-active');
      d.classList.add('is-done');
    });
    var thanksEl = root.querySelector('[data-ef-thanks]');
    if (thanksEl) requestAnimationFrame(function () { thanksEl.classList.add('is-shown'); });
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return;
  }

  var pages = $$('[data-ef-page]');
  var dots = $$('[data-ef-step-dot]');
  function showStep(n) {
    each(pages, function (p) {
      p.classList.toggle('is-active', String(n) === p.getAttribute('data-ef-page'));
    });
    each(dots, function (d) {
      var step = Number(d.getAttribute('data-ef-step-dot'));
      d.classList.toggle('is-active', step === n);
      d.classList.toggle('is-done', step < n);
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  var emailInput = root.querySelector('[data-ef-email]');
  var emailContinue = root.querySelector('[data-ef-next="2"]');
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((v || '').trim()); }
  if (emailInput && emailContinue) {
    emailInput.addEventListener('input', function () {
      emailContinue.disabled = !validEmail(emailInput.value);
    });
    emailInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && validEmail(emailInput.value)) {
        e.preventDefault();
        showStep(2);
      }
    });
  }

  function bindNav(sel, attr) {
    each($$(sel), function (btn) {
      btn.addEventListener('click', function () { showStep(Number(btn.getAttribute(attr))); });
    });
  }
  bindNav('[data-ef-next]', 'data-ef-next');
  bindNav('[data-ef-back]', 'data-ef-back');

  var listEl = root.querySelector('[data-ef-cards]');

  function getCardCopy(card) {
    var copy = CARD_COPY[card && card.getAttribute('data-ef-card')];
    if (!copy) return null;
    var lever = card.querySelector('.sc-ef__lever');
    var statement = card.querySelector('.sc-ef__stmt');
    return {
      lever: copy.lever || (lever && lever.textContent.trim()) || '',
      statement: copy.statement || (statement && statement.textContent.trim()) || ''
    };
  }

  function applyCanonicalCardCopy() {
    if (!listEl) return;
    each(listEl.children, function (card) {
      var copy = getCardCopy(card);
      if (!copy) return;
      var lever = card.querySelector('.sc-ef__lever');
      var stmt = card.querySelector('.sc-ef__stmt');
      if (lever) lever.textContent = copy.lever;
      if (stmt) stmt.textContent = copy.statement;
    });
  }
  applyCanonicalCardCopy();

  // Shuffle once — forces active re-rank
  if (listEl) {
    var children = Array.prototype.slice.call(listEl.children);
    for (var i = children.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = children[i]; children[i] = children[j]; children[j] = t;
    }
    children.forEach(function (c) { listEl.appendChild(c); });
  }

  function renderRanks() {
    if (!listEl) return;
    var n = listEl.children.length;
    each(listEl.children, function (card, idx) {
      var rankEl = card.querySelector('[data-ef-rank]');
      if (rankEl) rankEl.textContent = String(idx + 1);
      var up = card.querySelector('[data-ef-up]');
      var down = card.querySelector('[data-ef-down]');
      if (up) up.disabled = idx === 0;
      if (down) down.disabled = idx === n - 1;
    });
  }
  renderRanks();

  function bumpCard(card) {
    card.classList.add('is-bumped');
    setTimeout(function () { card.classList.remove('is-bumped'); }, 320);
  }

  function setDragging(isDragging) {
    root.classList.toggle('is-dragging', isDragging);
  }
  function clearDraggingSoon() {
    setTimeout(function () { setDragging(false); }, 0);
  }
  each($$('.sc-ef__handle'), function (handle) {
    handle.addEventListener('pointerdown', function () { setDragging(true); });
    handle.addEventListener('touchstart', function () { setDragging(true); }, { passive: true });
  });
  window.addEventListener('pointerup', clearDraggingSoon);
  window.addEventListener('pointercancel', clearDraggingSoon);
  window.addEventListener('touchend', clearDraggingSoon, { passive: true });
  window.addEventListener('touchcancel', clearDraggingSoon, { passive: true });

  function initSortable() {
    if (!listEl || !window.Sortable) return;
    window.Sortable.create(listEl, {
      animation: 220,
      easing: 'cubic-bezier(0.4, 0, 0.2, 1)',
      handle: '.sc-ef__handle',
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      fallbackClass: 'sortable-fallback',
      forceFallback: true,
      fallbackOnBody: true,
      fallbackTolerance: 4,
      onChoose: function (e) {
        e.item.classList.add('is-touched');
        setDragging(true);
      },
      onUnchoose: function (e) {
        e.item.classList.remove('is-touched');
      },
      onEnd: function () {
        setDragging(false);
        renderRanks();
      }
    });
  }
  if (window.Sortable) {
    initSortable();
  } else {
    var s = document.createElement('script');
    s.src = SORTABLE_CDN;
    s.async = true;
    s.onload = initSortable;
    document.head.appendChild(s);
  }

  function bindArrow(sel, isUp) {
    each($$(sel), function (btn) {
      btn.addEventListener('click', function () {
        var card = btn.closest('.sc-ef__card');
        var sib = card && (isUp ? card.previousElementSibling : card.nextElementSibling);
        if (!card || !sib) return;
        listEl.insertBefore(isUp ? card : sib, isUp ? sib : card);
        renderRanks();
        bumpCard(card);
      });
    });
  }
  bindArrow('[data-ef-up]', true);
  bindArrow('[data-ef-down]', false);

  // Done → assemble body, fill hidden fields, then let Shopify submit natively.
  var doneBtn = root.querySelector('[data-ef-done]');
  var form = root.querySelector('form#sc-ef-form');
  var hiddenSubject = root.querySelector('[data-ef-hidden-subject]');
  var hiddenName = root.querySelector('[data-ef-hidden-name]');
  var hiddenBody = root.querySelector('[data-ef-hidden-body]');
  var openTextarea = root.querySelector('[data-ef-open]');

  function populateSubmissionFields() {
    if (!emailInput || !validEmail(emailInput.value)) {
      showStep(1);
      if (emailInput) emailInput.focus();
      return false;
    }
    if (!listEl) {
      showStep(2);
      return false;
    }

    var customerEmail = (emailInput.value || '').trim();
    var lines = [
          translate('pages.early_feedback.submission.feedback_heading'),
          '',
          translate('pages.early_feedback.submission.email_label') + ': ' + customerEmail,
          '',
          translate('pages.early_feedback.submission.rank_heading')
    ];
    each(listEl.children, function (card, idx) {
      var copy = getCardCopy(card);
      var lever = card.querySelector('.sc-ef__lever');
      var stmt = card.querySelector('.sc-ef__stmt');
      var leverText = copy ? copy.lever : (lever ? lever.textContent.trim() : card.getAttribute('data-ef-card'));
      var stmtText = copy ? copy.statement : (stmt ? stmt.textContent.trim() : '');
      lines.push('  ' + (idx + 1) + '. ' + leverText);
      if (stmtText) lines.push('     ' + stmtText);
    });
    var openVal = openTextarea ? (openTextarea.value || '').trim() : '';
    lines.push('', translate('pages.early_feedback.submission.open_heading'), openVal || translate('pages.early_feedback.submission.none'));

    if (hiddenSubject) hiddenSubject.value = translate('pages.early_feedback.submission.subject_prefix') + customerEmail;
    if (hiddenName) hiddenName.value = translate('pages.early_feedback.submission.name');
    if (hiddenBody) hiddenBody.value = lines.join('\n');
    return true;
  }

  if (doneBtn) {
    doneBtn.addEventListener('click', function (event) {
      if (!emailInput || !validEmail(emailInput.value)) {
        event.preventDefault();
        showStep(1);
        if (emailInput) emailInput.focus();
      }
    });
  }

  if (form) {
    form.addEventListener('submit', function (event) {
      if (!populateSubmissionFields()) {
        event.preventDefault();
      }
    });
  }
})();
